export default function setFileNameExtension(filename, extension) {
  if (!extension) return filename;
  var preparedExtension = ".".concat(extension);
  if (filename.endsWith(preparedExtension)) return filename;
  return filename.concat(preparedExtension);
}